const profileValidationFR = {
    "email": {
        "required": "L'adresse e-mail est requise"
    },
    "profile_image": {
        "dimensions": "La taille de l'image de profil doit être exactement de 300 x 300 px, JPG/JPEG. Taille maximale du fichier 300 KB",
        "choose": "Veuillez choisir une image",
        "file": "Le fichier sélectionné est plus grand que 300 KB. Veuillez télécharger une couverture en 300x300 px, JPG/JPEG, taille maximale du fichier 300 KB."
    },
    "street_and_number": {
        "required": "La rue et le numéro de maison sont requis"
    },
    "postal_code": {
        "required": "Le code postal est requis"
    },
    "city": {
        "required": "La ville est requise"
    },
    "country": {
        "required": "Le pays est requis"
    },
    "vat_number": {
        "invalid": "La valeur n'est pas un numéro de TVA valide"
    },
    "iban": {
        "required": "L'IBAN est requis",
        "invalid": "La valeur n'est pas un numéro IBAN valide"
    },
    "cardholder_name": {
        "required": "Le nom du titulaire de la carte est requis"
    },
    "card_number": {
        "required": "Le numéro de carte est requis",
        "invalid": "Le numéro de carte n'est pas valide"
    },
    "card_year": {
        "required": "L'année d'expiration est requise",
        "invalid": "L'année d'expiration n'est pas valide"
    },
    "card_month": {
        "required": "Le mois d'expiration est requis"
    },
    "cvc_code": {
        "required": "Le code de sécurité (CVC) est requis",
        "invalid": "Le code de sécurité (CVC) n'est pas valide"
    },
    "paypal_email": {
        "required": "L'e-mail Paypal est requis",
        "invalid": "L'e-mail Paypal n'est pas valide"
    },
    "account_holder_name": {
        "required": "Le nom du titulaire du compte bancaire est requis"
    },
    "bank_name": {
        "required": "Le nom de la banque est requis"
    },
    "bank_address": {
        "required": "L'adresse de la banque est requise"
    },
    "preferred_payment_method": {
        "required": "La méthode de paiement préférée est requise"
    }
};

export default profileValidationFR;